import React, {Fragment} from "react";
import {ApplicationState, ConnectedReduxProps} from "@reducers/index";
import {TrackerPolicy} from "@models/tracker-policy";
import Form from "@components/tracker-policies/Form";
import {injectIntl} from "react-intl";
import api from "@api/tracker-policy";


interface PropsFromState {
  loading: boolean;
  data: TrackerPolicy[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class TrackerPolicyFormPage extends React.Component<AllProps> {
  state = {
    trackerPolicy: null,
    id: this.props.match.params.id,
    is_fetched: false
  };
  
  componentDidMount() {
    if (this.state.id) {
      this.fetchItem();
    }
  }
  
  fetchItem = () => {
    api.getItem({
        params: {
          id: this.state.id
        }
      })
      .then(({data}) => {
        this.setState({
          trackerPolicy: data
        });
      })
      .catch(error => {
      });
  };
  
  updateRequest = ({payload, params}) => {
    api.update({
        payload, params
      })
      .then((data) => {
        console.log("success")
      })
      .catch(error => console.log(error))
  };
  
  createRequest = ({payload}) => {
    api.create({
        payload
      })
      .then((data) => {
        console.log("sucess")
      })
      .catch(error => console.log(error))
  };
  
  getContent = () => {
    if (this.state.id && !this.state.trackerPolicy) {
      return null;
    }
    
    return (
      <Form
        trackerPolicy={this.state.trackerPolicy}
        intl={this.props.intl}
        listUrl={"/tracker-policies/"}
        history={this.props.history}
        updateRequest={this.updateRequest}
        createRequest={this.createRequest}
      />
    );
  };
  
  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}


export default injectIntl(TrackerPolicyFormPage)
